export default __webpack_public_path__ + "static/media/andrew-1.1275731a.svg";